declare global {
  interface Window {
    jwplayer: (element: HTMLDivElement | null) => {
      setup: (
        options: Partial<{
          playlist: string;
          width: string;
          aspectratio: string;
          displaydescription: boolean;
          displaytitle: boolean;
        }>,
      ) => {
        on: (event: string, callback: () => void) => void;
        getAudioTracks: () => { language: string; hlsjsIndex: number }[];
        setCurrentAudioTrack: (index: number) => void;
        seek: (time: number) => void;
        remove: () => void;
      };
    };
  }
}

export const jwplayer = window.jwplayer;
